import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subgenome_list: [],
    synorths_sheet: [],
    tripling_dict: {},
    subgenome_information: [],
    show_result: 0,
    search_gene: '',
    checkList: '',
    links: [],
    fragment_length: [],
    gene: [],
    cds: [],
    border: {},
    gene1: '',
    gene2: '',
  },
  mutations: {
    editSubgenomeList(state, list1) {
      state.subgenome_list = list1;
    },
    editSynorthsSheet(state, sheet1) {
      state.synorths_sheet = sheet1;
    },
    editTriplingDict(state, dict1) {
      state.tripling_dict = dict1;
    },
    editSubgenomeInformation(state, information1) {
      state.subgenome_information = information1;
    },
    editShowResult(state, result1) {
      state.show_result = result1;
    },
    editSearchGene(state, gene1) {
      state.search_gene = gene1;
    },
    editCheckList(state, list1) {
      state.checkList = list1;
    },
    editLinks(state, links1) {
      state.links = links1;
    },
    editFragmentLength(state, length1) {
      state.fragment_length = length1;
    },
    editGene(state, gene1) {
      state.gene = gene1;
    },
    editCds(state, cds1) {
      state.cds = cds1;
    },
    editBorder(state, border1) {
      state.border = border1;
    },
    editGene1(state, gene1) {
      state.gene1 = gene1;
    },
    editGene2(state, gene2) {
      state.gene2 = gene2;
      // console.log(state);
    }
  },
  actions: {
  },
  modules: {
  }
})
